export const TabId = {
  Profile: "profile",
  SshKeys: "ssh-keys",
  Teammates: "teammates",
  Slack: "slack",
  Figma: "figma",
} as const

export type SettingsTabId = typeof TabId[keyof typeof TabId]

export function isTabId(value: string): value is SettingsTabId {
  return Object.values(TabId).includes(value as SettingsTabId)
}
